import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

/**
 * Whether the scheduling drawer uses the availability-aware appointment picker
 * (ECX-2929) instead of the flat month-and-time-list one — for every entry
 * point: add to calendar, reschedule, in-session and the patient profile.
 */
export const useAddToCalendarDayWeekMonth = (): boolean =>
  useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.ADD_TO_CALENDAR_DAY_WEEK_MONTH);
